import { MapStyle } from "@somewear/model";

export function getNextMapStyle(currentStyle?: MapStyle) {
	return currentStyle === MapStyle.Satellite ? MapStyle.Outdoors : MapStyle.Satellite;
}
